import { render, staticRenderFns } from "./menu-splash-screen.vue?vue&type=template&id=5af32852&scoped=true&"
import script from "./menu-splash-screen.vue?vue&type=script&lang=js&"
export * from "./menu-splash-screen.vue?vue&type=script&lang=js&"
import style0 from "./menu-splash-screen.vue?vue&type=style&index=0&id=5af32852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../WebVR/webvr-infest/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af32852",
  null
  
)

export default component.exports